
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import type { GetStaticProps, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import { OfficeContact } from '@/components/OfficeContact';
const Index: NextPage = function () {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-center bg-white'>
      <div className='flex max-w-7xl flex-col justify-center space-y-4 bg-white px-12 py-4 lg:pb-52'>
        <h4 className='title'>{t('privacy:Privacy')}</h4>
        <h3 className='subtitle'>{t('privacy:subtitle')}</h3>
        <OfficeContact />
        <p>{t('privacy:paragraph1')}</p>
        <p>{t('privacy:paragraph2')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:personal-data.title')}
        </h3>
        <p> {t('privacy:personal-data.paragraph1')}</p>
        <p> {t('privacy:personal-data.paragraph2')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:purpose-collect-data.title')}
        </h3>
        <p>{t('privacy:purpose-collect-data.paragraph1')}</p>
        <ul className='list-inside list-disc'>
          <li>{t('privacy:purpose-collect-data.paragraph2')}</li>
          <li>{t('privacy:purpose-collect-data.paragraph3')}</li>
          {t('privacy:purpose-collect-data.paragraph4', {}, { default: ' ' })
            .length > 2 && (
            <li>
              {t(
                'privacy:purpose-collect-data.paragraph4',
                {},
                { default: ' ' }
              )}
            </li>
          )}
        </ul>
        <h3 className='title pt-8 font-light'>
          {t('privacy:data-entry.title')}
        </h3>
        <h2>{t('privacy:data-entry.paragraph1')}</h2>
        <ul className='list-inside list-disc'>
          <li>{t('privacy:data-entry.list-item1')}</li>
          <li>{t('privacy:data-entry.list-item2')}</li>
          <li>{t('privacy:data-entry.list-item3')}</li>
          <li>{t('privacy:data-entry.list-item4')}</li>
          <li>{t('privacy:data-entry.list-item5')}</li>
          <li>{t('privacy:data-entry.list-item6')}</li>
        </ul>
        <p>{t('privacy:data-entry.paragraph2')}</p>
        <p>
          <Trans
            i18nKey='privacy:data-entry.paragraph3'
            components={{
              a: (
                <a
                  className='link'
                  href='https://www.gindumac.de/cookie-richtlinie'
                />
              ),
            }}
          />
        </p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:google-analytics.title')}
        </h3>
        <p>{t('privacy:google-analytics.paragraph1')}</p>
        <p>{t('privacy:google-analytics.paragraph2')}</p>
        <p>{t('privacy:google-analytics.paragraph3')}</p>
        <p>
          <Trans
            i18nKey='privacy:google-analytics.paragraph4'
            components={{
              a: (
                <a
                  className='link'
                  href='http://tools.google.com/dlpage/gaoptout?hl=de'
                />
              ),
            }}
          />
        </p>
        <p>{t('privacy:google-analytics.paragraph5', {}, { default: ' ' })}</p>
        <p>{t('privacy:google-analytics.paragraph6', {}, { default: ' ' })}</p>
        <h3 className='title pt-8 font-light'>{t('privacy:add-roll.title')}</h3>
        <p>
          <Trans
            i18nKey='privacy:add-roll.paragraph1'
            components={{
              a: (
                <a
                  className='link'
                  href='http://optout.networkadvertising.org/?c=1#!/'
                />
              ),
            }}
          />
        </p>
        {t('privacy:hotjar.title', {}, { default: ' ' }).length > 2 && (
          <>
            <h3 className='title pt-8 font-light'>
              {t('privacy:hotjar.title')}
            </h3>
            <p>
              <Trans
                i18nKey='privacy:hotjar.paragraph1'
                components={{
                  a: <a className='link' href='https://www.hotjar.com/' />,
                }}
              />
            </p>
            <p>{t('privacy:hotjar.paragraph2')}</p>
            <p>
              <Trans
                i18nKey='privacy:hotjar.paragraph3'
                components={{
                  a: (
                    <a
                      className='link'
                      href='https://www.hotjar.com/legal/policies/privacy'
                    />
                  ),
                }}
              />
            </p>
            <p>
              <Trans
                i18nKey='privacy:hotjar.paragraph4'
                components={{
                  a: (
                    <a
                      className='link'
                      href='https://www.hotjar.com/legal/compliance/opt-out'
                    />
                  ),
                }}
              />
            </p>
          </>
        )}
        <h3 className='title pt-8 font-light'>
          {t('privacy:data-protection.title')}
        </h3>
        <p>{t('privacy:data-protection.paragraph1')}</p>
        <p>{t('privacy:data-protection.paragraph2')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:consert-and-revocation.title')}
        </h3>
        <p>{t('privacy:consert-and-revocation.paragraph1')}</p>
        <p className='font-bold'>
          <Trans
            i18nKey='privacy:consert-and-revocation.paragraph2'
            components={{
              br: <br />,
            }}
          />
        </p>
        <p>{t('privacy:consert-and-revocation.paragraph3')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:transmission.title')}
        </h3>
        <p>{t('privacy:transmission.paragraph1')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:duration-data-storage.title')}
        </h3>
        <p>{t('privacy:duration-data-storage.paragraph1')}</p>
        <h3 title='title'>{t('privacy:data-security.title')}</h3>
        <p>{t('privacy:data-security.paragraph1')}</p>
        <h3 className='title pt-8 font-light'>
          {t('privacy:information.title')}
        </h3>
        <p>{t('privacy:information.paragraph1')}</p>
        <h3 className='title pt-8 font-light'>{t('privacy:credit.title')}</h3>
        <p>{t('privacy:credit.paragraph1')}</p>
        <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3'>
          <div className=''>
            <p>– Creditsafe Deutschland GmbH</p>
            <p>Schreiberhauer Straße 30</p>
            <p>10317 Berlin</p>
            <a href='http://www.creditsafede.com' className='link'>
              https://www.creditsafede.com
            </a>
          </div>
          <div className=''>
            <p>– CEG Creditreform Boniversum GmbH</p>
            <p>(Germany)</p>
            <p>Hellerbergstraße 11</p>
            <p>D-41460 Neuss</p>
            <a href='http://meineauskunft.org' className='link'>
              http://meineauskunft.org
            </a>
          </div>
          <div className=''>
            <p>– Schufa Holding AG</p>
            <p>Kormoranweg 5</p>
            <p>65201 Wiesbaden</p>
            <a href='https://www.meineschufa.de' className='link'>
              https://www.meineschufa.de
            </a>
          </div>
          <div className=''>
            <p>– Bürgel Wirtschaftsinformationen</p>
            <p>GmbH & Co.KG</p>
            <p>Gasstraße 18</p>
            <p>22761 Hamburg</p>
            <a href='http://www.buergel.de' className='link'>
              http://www.buergel.de
            </a>
          </div>
          <div className=''>
            <p>– Infoscore Consumer Data GmbH</p>
            <p>(Germany)</p>
            <p>Department of Data protection</p>
            <p>76532 Baden-Baden</p>
            <a href='http://www.arvato-infoscore.de' className='link'>
              http://www.arvato-infoscore.de
            </a>
          </div>
        </div>
        <p>{t('privacy:credit.paragraph2')}</p>
        <p className='pt-12'>{t('privacy:credit.paragraph3')}</p>
        <p>{t('privacy:credit.paragraph4')}</p>
        <p>{t('privacy:credit.paragraph5')}</p>
        <p>{t('privacy:credit.paragraph6')}</p>
        <p>{t('privacy:credit.paragraph7')}</p>
      </div>
    </div>
  );
};

 const _getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};

export default Index;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/privacy',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  